import React from 'react';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import icNotify from 'assets/svg/ic_notify_v2.svg';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';

const LimitWarningModal = ({
  onContinue,
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icNotify
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "Once the hero reached the limit Thetan Coin battle, you won\u2019t be able to earn any in-game Thetan Coin in the battle"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    title: "Go back",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Continue buying",
    onClick: onContinue
  })))));
};

export default LimitWarningModal;